import { render, staticRenderFns } from "./ComponentForm.vue?vue&type=template&id=4fc622ee&scoped=true&"
import script from "./ComponentForm.vue?vue&type=script&lang=js&"
export * from "./ComponentForm.vue?vue&type=script&lang=js&"
import style0 from "./ComponentForm.vue?vue&type=style&index=0&id=4fc622ee&scoped=true&lang=css&"
import style1 from "./ComponentForm.vue?vue&type=style&index=1&id=4fc622ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc622ee",
  null
  
)

export default component.exports